// src/kcgBottomSheet/KcgQuestion.js
import React, { useState } from "react";
import "../../kcgbetsy/kcgBottomSheet/BottomSheet.css";
import { IconButton, List, Snackbar } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ArrowCircleUpIcon from "@mui/icons-material/ArrowCircleUp";
import ArrowCircleDownIcon from "@mui/icons-material/ArrowCircleDown";
import { pre_defined_questions } from "./Questions";

const BetsyQuestion = ({ setInput }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [copySnackbarOpen, setCopySnackbarOpen] = useState(false);
  const [snackBarMsg, setSnackbarMsg] = useState(false);

  const itemsPerPage = 8;
  const [currentPage, setCurrentPage] = useState(0);
  const totalPages = Math.ceil(pre_defined_questions.length / itemsPerPage);

  const questionsToDisplay = pre_defined_questions.slice(
    currentPage * itemsPerPage,
    currentPage * itemsPerPage + itemsPerPage
  );

  const handleNextPage = () => {
    if (currentPage < totalPages - 1) setCurrentPage(currentPage + 1);
  };

  const handlePreviousPage = () => {
    if (currentPage > 0) setCurrentPage(currentPage - 1);
  };

  return (
    <>
      {/* Backdrop on Mobile */}
      {isOpen && window.innerWidth <= 768 && (
        <div className="kcg-drawer-backdrop" onClick={() => setIsOpen(false)} />
      )}

      {/* Bottom Sheet / Side Drawer */}
      <div className={`bottom-sheet ${isOpen ? "open" : ""}`}>
        {/* Snackbar */}
        <Snackbar
          open={copySnackbarOpen}
          autoHideDuration={2000}
          onClose={() => setCopySnackbarOpen(false)}
          message={<span className="snackbarmsg">{snackBarMsg}</span>}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          action={
            <IconButton
              size="small"
              aria-label="close"
              color="inherit"
              onClick={() => setCopySnackbarOpen(false)}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          }
        />

        {/* Desktop Handle */}
        <div className="handle desktop-only">
          {isOpen ? (
            <ArrowCircleDownIcon
              onClick={() => setIsOpen(false)}
              style={{ color: "#fff" }}
            />
          ) : (
            <ArrowCircleUpIcon
              onClick={() => setIsOpen(true)}
              style={{ color: "#fff" }}
            />
          )}
        </div>

        {/* Mobile Close Button */}
        {isOpen && (
          <div
            className="kcg-fab-close mobile-only"
            onClick={() => setIsOpen(false)}
          >
            ✕
          </div>
        )}

        {/* Sheet Content */}
        <div className="sheet-content">
          <p className="sheet-content-title">
            List of Questions you can ask BETSY
          </p>
          <List>
            {questionsToDisplay.map((question, index) => (
              <div
                key={index}
                className="kcg-bordered"
                onClick={() => setInput(question)}
              >
                {question.length > 70
                  ? question.slice(0, 70) + "..."
                  : question}
              </div>
            ))}
          </List>

          <div className="pagination">
            <IconButton
              onClick={handlePreviousPage}
              disabled={currentPage === 0}
            >
              <ArrowBackIcon style={{ color: "#fff" }} />
            </IconButton>
            <span>
              Page {currentPage + 1} of {totalPages}
            </span>
            <IconButton
              onClick={handleNextPage}
              disabled={currentPage === totalPages - 1}
            >
              <ArrowForwardIcon style={{ color: "#fff" }} />
            </IconButton>
          </div>
        </div>
      </div>

      {/* FAB Toggle for Mobile */}
      {!isOpen && (
        <button className="kcg-fab mobile-only" onClick={() => setIsOpen(true)}>
          <ArrowBackIcon />
        </button>
      )}
    </>
  );
};

export default BetsyQuestion;
